import { TeamDomainQueryModelSchema } from '@mntn-dev/domain-types'
import type { ZodInfer } from '@mntn-dev/utility-types'

import { GetTeamOutputSchema } from './get-team.models.ts'

export const ListTeamsInputSchema = TeamDomainQueryModelSchema.pick({
  organizationId: true,
})

export type ListTeamsInput = ZodInfer<typeof ListTeamsInputSchema>

export const ListTeamsOutputSchema = GetTeamOutputSchema.array()

export type ListTeamsOutput = ZodInfer<typeof ListTeamsOutputSchema>
